// exp_cli/src/app/utils/logger.js
const LOG_ENDPOINT = process.env.REACT_APP_RUN_ENV === 'development'
  ? `${process.env.REACT_APP_API_BASE_URL_DEV}/api/logs`
  : `${process.env.REACT_APP_API_BASE_URL}/api/logs`;

const IP_ENDPOINT = process.env.REACT_APP_RUN_ENV === 'development'
  ? `${process.env.REACT_APP_API_BASE_URL_DEV}/api/getIP`
  : `${process.env.REACT_APP_API_BASE_URL}/api/getIP`;

// Custom logger for winston in Node.js
//console.log(logger.levels);	// <-- only works in Node.js
//logger.error('---------------- error', LOG_LOC);
//logger.warn('---------------- warn', LOG_LOC);
//logger.info('---------------- info', LOG_LOC);
//logger.debug('---------------- debug', LOG_LOC);	<--- Suppored by some browser

class Logger {
  constructor() {
    this.clientIP = '';
    this.userId = '';
    //this.fetchClientIP();
  }

  async fetchClientIP() {
    try {
      const response = await fetch(IP_ENDPOINT);
      const data = await response.json();
      this.clientIP = data.ip;
    } catch (error) {
      console.error('Failed to fetch client IP', error);
    }
  }

  setUserId(userId) {
    this.userId = userId;
  }

  log(level, message, meta = {}) {
    //		const { /*clientIP,*/ userId, ...restMeta } = meta;
    const logEntry = {
      timestamp: new Date().toISOString(),
      level,
      // clientIP: this.clientIP,
      message,
      //			userId: this.userId,
      ...meta,
    };

    // Log to console
    // Console supports only 
    if (meta.location) {
      console[level](`[${meta.location}] ${message}`, logEntry);
    } else {
      console[level](message, logEntry);
    }

    // Send to backend
    if (process.env.REACT_APP_SEND_LOG_TO_BACKEND === 'true')
      this.sendToBackend(logEntry);
  }

  async sendToBackend(logEntry) {
    try {
      await fetch(LOG_ENDPOINT, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(logEntry),
      });
    } catch (error) {
      console.error('Failed to send log to server', error);
    }
  }

  // windton log level(error: 0, warn: 1, info: 2, http: 3, verbose: 4, debug: 5, silly: 6)
  error(message, meta) {
    this.log('error', message, meta);
  }

  warn(message, meta) {
    this.log('warn', message, meta);
  }

  info(message, meta) {
    this.log('info', message, meta);
  }

  debug(message, meta) {
    this.log('debug', message, meta);
  }
}

const logger = new Logger();
export default logger;